"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ValidationError_1 = require("auto-widget-framework/src/Error/ValidationError");
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
class QuestionnaireFormValidator {
    constructor(formElement, questionnaires, mappingValidator, questionnaireToValidationMappingTransformer, formValuesToObjectTransformer) {
        this.formElement = formElement;
        this.mappingValidator = mappingValidator;
        this.questionnaires = questionnaires;
        this.questionnaireToValidationMappingTransformer = questionnaireToValidationMappingTransformer;
        this.formValuesToObjectTransformer = formValuesToObjectTransformer;
        this.mapping = this.questionnaireToValidationMappingTransformer.to(questionnaires);
    }
    /**
     * @inheritDoc
     */
    static create(formElement, questionnaires, container) {
        return new this(formElement, questionnaires, container.get("mapping_validator"), container.get("transformer.questionnaire_to_validation_mapping"), container.get("transformer.form_values_to_object"));
    }
    /**
     * @inheritDoc
     */
    validate(values) {
        return Promise.resolve().then(() => {
            try {
                this.mappingValidator.validate(values, "Questionnaire validation failed.", this.mapping);
            }
            catch (validationErrors) {
                if (validationErrors instanceof ValidationError_1.default) {
                    return validationErrors;
                }
                throw validationErrors;
            }
            return null;
        });
    }
    /**
     * @inheritDoc
     */
    validateField(inputName, value) {
        return Promise.resolve().then(() => {
            // @TODO: See if better way can be found for handling this.
            // This is to handle the case of array fields values.
            inputName = inputName.replace("[]", "");
            const fieldMapping = this.mapping.value[inputName];
            if (!fieldMapping) {
                return null;
            }
            try {
                this.mappingValidator.validate({
                    [inputName]: value
                }, "Questionnaire validation failed.", {
                    type: "object",
                    value: { [inputName]: fieldMapping }
                });
            }
            catch (validationErrors) {
                if (validationErrors instanceof ValidationError_1.default) {
                    return validationErrors.getValidationErrors()[inputName];
                }
                throw validationErrors;
            }
            return null;
        });
    }
}
exports.default = QuestionnaireFormValidator;
Mixin_1.default(QuestionnaireFormValidator, IContainerInjection_1.default);
